import { Icon } from '@chakra-ui/react';

export default function SFEnvelopeIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width={5}
      height='15px'
      fill='currentColor'
      viewBox='0 0 20 15'
      {...props}
    >
      <path d='M3.023 14.102c-1.625 0-2.453-.813-2.453-2.422V3.055c0-1.61.82-2.422 2.22-2.422h14.179c1.625 0 2.453.812 2.453 2.422v8.625c0 1.61-.82 2.422-2.219 2.422zm6.22-6.204c.241.22.491.32.75.32.257 0 .507-.1.75-.32l6.679-6.023a1.7 1.7 0 0 0-.414-.047H2.977c-.149 0-.29.016-.414.047zm8.984-4.843a1.5 1.5 0 0 0-.032-.328l-4.78 4.304 4.804 4.805c.008-.047.008-.102.008-.156zM1.766 11.672q-.002.083.007.164l4.805-4.797L1.79 2.734a2 2 0 0 0-.023.313zm1.21 1.234h14.032a1.5 1.5 0 0 0 .555-.094l-5.008-5.007-1.133 1.023c-.445.406-.93.594-1.43.594s-.984-.188-1.43-.594L7.43 7.805l-5 5.008c.156.062.343.093.547.093' />
    </Icon>
  );
}
